import PageHeader from '../components/PageHeader.jsx';
import Practice from '../components/Practice.jsx';
import SnapPage from '../components/SnapPage.jsx';
import T from '../i18n/content.js';
import { useT } from '../i18n/LangContext.jsx';

export default function PracticePage() {
  const t = useT();
  const P = T.practice;
  return (
    <SnapPage>
      <PageHeader title={t(P.pageTitle)} lede={t(P.lede)} motif="motif-practice.png" motifSize="lg" lower />
      <Practice asPage />
    </SnapPage>
  );
}
